// AppRoutes.js
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import LoginPage from './Component/LoginPage/LoginPage';

import Checkout from './Component/checkout/Checkout';
import OrderHistoryMain1 from './Component/Orderhistory/orderHistoryMain1';
import InvoiceReport from './Component/GenerateReport/generateReport';
import StagesTable from './testTable/stagesTable';
import ReportStatement from './Component/leadgerStatement/ReportsStatement';
import ItemPageWrapper from './Component/itemPage/itempageWrapper';
import DashboardTest from './Component/Dashboard/DashTest';

const AppRoutes = () => {
  const location = useLocation();

  return (
    <Routes>
      
      <Route path="/" element={<LoginPage />} />
      {/* <Route path="/DashBoard" element={<Dashboard />} /> */}
      <Route path="/DashBoard" element={<DashboardTest />} />
      <Route path="/Checkout" element={<Checkout />} />
      <Route path="/orderHistory" element={<OrderHistoryMain1 />} />
      <Route path="/ReportTemplate" element={<InvoiceReport />} />
      <Route path="/stagesTable" element={<StagesTable />} />
      <Route path="/Reports" element={<ReportStatement />} />
      <Route path="/ItemPage" element={<ItemPageWrapper key={location.pathname} />} />
    </Routes>
  );
};

export default AppRoutes;
